<script lang="ts">
	import SbRichtext from '../components/sbRichtext.svelte';
	import PageGrid16 from '../components/pageGrid16.svelte';
	import { editable } from '../editable';
	import type { ISbRichtext, ISbStoryData } from '@storyblok/js';
	import Blok from '../blok.svelte';
	import Carousel from '$lib/carousel.svelte';
	import TimedGalleryIndicator from '$lib/timedGalleryIndicator.svelte';
	import type { EmblaCarouselType } from 'embla-carousel';
	import ArrowLeft from '$lib/icons/arrowLeft.svelte';
	import Button from '$lib/buttons/v3/button.svelte';
	import { fly } from 'svelte/transition';
	import ArrowRight from '$lib/icons/arrowRight.svelte';

	interface Props {
		content: ISbStoryData<{
			headline: string | ISbRichtext;
			gallery_items: ISbStoryData[];
		}>['content'];
	}

	let { content }: Props = $props();

	let active = $state(0);
	let embla = $state<EmblaCarouselType>();

	function next() {
		if (embla) {
			embla.canScrollNext() ? embla.scrollNext() : embla.scrollTo(0);
		}
	}

	function previous() {
		if (embla) {
			embla.canScrollPrev() ? embla.scrollPrev() : embla.scrollTo(content.gallery_items.length - 1);
		}
	}
</script>

<section use:editable={content} class="relative overflow-x-hidden text-brown-1">
	<PageGrid16 margin>
		<div class="col-span-full mb-8 text-center lg:col-start-5 lg:col-end-[13] lg:mb-12">
			{#if content.headline}
				<h1
					class=" text-[44px]/[108%] tracking-[-.44px] lg:text-[64px]/[104%] lg:tracking-[-.64px]"
				>
					<SbRichtext text={content.headline} />
				</h1>
			{/if}
		</div>
	</PageGrid16>

	<div class="relative">
		<PageGrid16 margin>
			<div class="relative col-span-full lg:col-start-3 lg:col-end-[15]">
				<Carousel
					bind:embla
					bind:currentIndex={active}
					overflow
					autoplay={false}
					class={['flex gap-x-7']}
					align="center"
				>
					{#each content.gallery_items as item}
						<div class={['flex-none basis-full']}>
							<Blok content={item} />
						</div>
					{/each}
				</Carousel>
			</div>
		</PageGrid16>

		{#if active !== 0}
			<div
				class="absolute left-6 top-[calc(50%-64px)] max-lg:hidden"
				transition:fly={{ x: '-100%' }}
			>
				<Button onclick={previous} class="btn-white">
					<ArrowLeft />
				</Button>
			</div>
		{/if}

		{#if active !== content.gallery_items.length - 1}
			<div
				class="absolute right-6 top-[calc(50%-64px)] max-lg:hidden"
				transition:fly={{ x: '100%' }}
			>
				<Button onclick={next} class="btn-white">
					<ArrowRight />
				</Button>
			</div>
		{/if}
	</div>
	{#if embla}
		<div class="mt-4 flex justify-center lg:mt-7">
			<TimedGalleryIndicator theme="brown" {active} {embla} count={content.gallery_items.length} />
		</div>
	{/if}
</section>
